export const HeaderSolutions = [
   { href: "/search", label: "Find Workspace" },
   { href: "/workplace-manager", label: "Manage Hybrid Teams" },
   { href: "/share-office-meeting-space", label: "List Your Coworking Space" },
];